import { ISectionLogger } from "./ISectionLogger";
import { LoggingSectionType } from "./types";

/**
 * Továrna pro získávání nových instancí {@link ISectionLogger}-u.
 * (Použito interně - v rámci Logging-modulu. Navenek by měla stačit funkce _createSectionLogger_.)
 *
 * Implementace továrny je v DIContaineru, tak je možné ji nahradit za custom.
 * - Ale neměl by k tomu být důvod. (Výchozí implementace by měla být dostačující.)
 * - Pro zákaznické implementace je určeno primárně rozhraní {@link ILogger}.
 *
 * @includeToDoc
 */
export interface ISectionLoggerFactory {
    /**
     * Vrátí novou instanci {@link ISectionLogger}.
     * @param section SectionLogger bude vytvořen pro tuto oblast.
     */
    create(section: LoggingSectionType): ISectionLogger;
}

export class ISectionLoggerFactory {
    private static _properties: string[] = [];
    private static _methods = ["create"];

    // zápis kvůli ES5
    public static get [Symbol.hasInstance](): (instance: any) => boolean {
        return (instance: any) => instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
        !this._methods.some(value => typeof instance[value] !== "function");
    }
}
